import React from "react";

interface Comment {
  _id: string;
  commentAuthor: string;
  commentText: string;
  commentLikes: number;
}

interface SeeCommentProps {
  comments: Comment[];
  onClose: () => void; 
}

export const SeeComment: React.FC<SeeCommentProps> = ({ comments, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-80 z-50">
      <div className="bg-gray-900 p-6 rounded-lg shadow-lg max-w-md w-full h-5/6 overflow-y-auto relative">
        <button 
          onClick={onClose}
          className="absolute top-2 right-2 text-white hover:text-red-600 transition"
          aria-label="Close"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-6 w-6" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M6 18L18 6M6 6l12 12" 
            />
          </svg>
        </button>

        <h2 className="text-xl font-bold text-white mb-4">Comments</h2>
        {comments.length > 0 ? (
          comments.map((comment) => (
            <div key={comment._id} className="mb-4">
              <p>
                <strong>{comment.commentAuthor || "Anonymous"}</strong>: {comment.commentText || "No comment text."}
              </p>
              <p className="text-sm text-gray-500">Likes: {comment.commentLikes}</p>
            </div>
          ))
        ) : (
          <p className="text-gray-400">No comments available.</p>
        )}
        <button
          onClick={onClose}
          className="mt-4 text-white bg-red-600 hover:bg-red-700 transition px-4 py-2 rounded-md"
        >
          Close
        </button>
      </div>
    </div>
  );
};
